import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {NbButtonModule, NbWindowService} from '@nebular/theme';
import {Catalog, CatalogWithAncestors, translations} from 'compob2b-libs';
import {
  ChooseCatalogModalComponent
} from '../../../../../compob2b-admin/src/app/admin-shared/choose-catalog-modal/choose-catalog-modal.component';
import {CatalogService} from '../../../../../compob2b-admin/src/app/cabinet/pim/catalog/catalog.service'
import {TuiIcon} from '@taiga-ui/core'

interface ContextType {
  catalogChosenEvent: EventEmitter<CatalogWithAncestors>;
  removeCatalogEvent: EventEmitter<CatalogWithAncestors>;
  chosenCatalogs?: Catalog[];
  onlyOneSelection?: boolean;
  chooseOnlyLastLevel?: boolean;
  excludeCatalogIds?: number[];
  catalogService: CatalogService;
}

@Component({
  selector: 'app-choose-catalog-input',
  templateUrl: './choose-catalog-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NbButtonModule,
    TuiIcon
  ]
})
export class ChooseCatalogInputComponent {
  @Output() catalogChosenEvent = new EventEmitter<CatalogWithAncestors>();
  @Output() removeCatalogEvent = new EventEmitter<CatalogWithAncestors>();
  @Input() onlyOneSelection: boolean = null;
  @Input() chooseOnlyLastLevel: boolean = null;
  @Input() title: string = translations.selectOneCatalog;
  @Input() chosenCatalogs: Catalog[] = [];
  @Input() excludeCatalogIds: number[] = [];
  @Input() catalogService: CatalogService;
  @Input() size = 'small';

  constructor(protected readonly windowService: NbWindowService) {
    if (!this.catalogService) {
      this.catalogService = inject(CatalogService);
    }
  }

  openChooseCatalogModal(): void {
    const data: ContextType = {
      catalogChosenEvent: this.catalogChosenEvent,
      removeCatalogEvent: this.removeCatalogEvent,
      chosenCatalogs: this.chosenCatalogs,
      excludeCatalogIds: this.excludeCatalogIds,
      catalogService: this.catalogService,
    };

    if (this.onlyOneSelection !== null) {
      data.onlyOneSelection = this.onlyOneSelection;
    }

    if (this.chooseOnlyLastLevel !== null) {
      data.chooseOnlyLastLevel = this.chooseOnlyLastLevel;
    }

    this.windowService.open(ChooseCatalogModalComponent, {
      context: data,
      title: this.title
    });
  }
}
